angular.module('lf.desktop')

.directive('checkoutBlock', function () {
  return {
    restrict: 'A',
    link: function (scope, el, attrs) {
      var $content = el.find('.checkout-block__content');

      attrs.$observe('expanded', function (isExpanded) {
        if (isExpanded) {
          $content.slideDown();
        } else {
          $content.slideUp();
        }
      });
    }
  }
});
